import { Content } from '../../types';

export const kohTaoContent: Content = {
  title: 'קו טאו - אי של שלווה, צלילה וחופים עוצרי נשימה',
  imageUrl: '/images/thailand/koh-tao/koh-tao-wide.jpeg',
  introduction:
    'קו טאו (Ko Tao), אשר משמעות שמו בתאילנדית הינו "אי הצבים", הינו פנינה טרופית קסומה בלב מפרץ תאילנד. מדובר באחד האיים המרהיבים ביותר במדינה – יעד אידיאלי לחובבי טבע, צלילה ומנוחה. עם חופים זהובים, מים בצבע טורקיז, שוניות אלמוגים שוקקות חיים ואווירה רגועה, קו טאו הפך לאתר חובה בכל טיול לתאילנד.',
  sections: [
    {
      title: 'המפגש הראשון עם האי',
      type: 'text',
      content:
        'הדרך לקו טאו נעשית באמצעות מעבורת מקו סאמוי או מקו פנגן, וכבר כשמתקרבים לרציף המרכזי Mae Haad, הנוף עוצר הנשימה מרמז על קסם מיוחד. ההרים הירוקים, הבקתות הצבעוניות והמים השקופים יוצרים תחושת בריחה מהעולם.\n\nלאורך המזח תמצאו שורת בתי קפה קטנים, מסעדות מקומיות ובינלאומיות, חנויות לציוד שנורקלינג וצלילה וסוכנויות טיולים. זהו המקום המושלם להתחיל בו את החופשה – עם קפה קר מול הים, בלי לחץ ובלי שעון.',
    },
    {
      title: 'חופים שאי אפשר לשכוח',
      type: 'sub-headers',
      description: 'קו טאו מתהדר במגוון חופים, כל אחד עם הקסם הייחודי שלו:',
      content: [
        {
          subtitle: 'Sairee Beach',
          text: 'החוף המרכזי והפופולרי באי. מושלם לשחייה, שנורקלינג, ספורט ימי, מסעדות וברים ולמופעי אש ססגוניים בשעות הערב.',
        },
        {
          subtitle: 'Ao Leuk Beach',
          text: 'חוף מבודד, אידיאלי לרוגע ושנורקלינג במים רדודים.',
        },
        {
          subtitle: 'Tanote Bay',
          text: 'פנינה לחובבי שוניות אלמוגים. מושלם לצפייה בדגים טרופיים ממש מהחוף.',
        },
        {
          subtitle: 'Shark Bay',
          text: 'לאלו הבטוחים בחוויית שנורלינג לצד כרישי שונית. חוויה מרגשת במיוחד.',
        },
        {
          subtitle: 'Sai Nuan Beach',
          text: 'חוף נסתר ופסטורלי, גן עדן לזוגות המחפשים פינה רומנטית ושקטה.',
        },
      ],
    },
    {
      title: 'צלילה, שנורקלינג והרפתקאות מתחת למים',
      type: 'sub-headers',
      description:
        'קו טאו נחשב לאחד מיעדי הצלילה הפופולריים בעולם – בעיקר בזכות המחירים הנוחים, בתי הספר האיכותיים והטבע התת - ימי המרהיב. קורסי צלילה (PADI או SSI) נמשכים לרוב 3–4 ימים, ובמהלכם תלמדו את עקרונות הצלילה ותתאמנו באתרי צלילה מובילים:',
      content: [
        {
          subtitle: 'Chumphon Pinnacle',
          text: 'אתר מפורסם המושך אליו צוללים מנוסים.',
        },
        {
          subtitle: 'Shark Island',
          text: 'מקום מושלם לראות דגים גדולים, אלמוגים - גם צבעוניים ולעיתים צבי ים.',
        },
        {
          subtitle: 'White Rock',
          text: 'אתר נגיש המתאים גם לצוללים מתחילים.',
        },
        {
          subtitle: 'שנורקלינג',
          text: 'לאלו המעדיפים להישאר קרוב לפני המים, ניתן לצאת לטיולי שנורקלינג עצמאיים או מאורגנים סביב האי. החופים המומלצים הם Hin Wong Bay, Mango Bay ו-Ao Leuk – כל אחד מהם מציע עולם תת-ימי שופע, קרוב מאוד לקו החוף.',
        },
      ],
    },
    {
      title: 'נקודות תצפית ושקיעות מרהיבות',
      type: 'sub-headers',
      description:
        'קו טאו מפורסם גם בזכות הנופים עוצרי הנשימה והאפשרויות הרבות לטיולים רגליים קלילים עם תצפיות נהדרות:',
      content: [
        {
          subtitle: 'John-Suwan Viewpoint',
          text: 'תצפית דרמטית בדרום האי, עם נוף פנורמי לשני צדי האי.',
        },
        {
          subtitle: 'Love Koh Tao Viewpoint',
          text: 'נקודת תצפית רומנטית עם ערסלים, בית קפה ונוף נפלא למפרץ Tanote.',
        },
        {
          subtitle: 'Fraggle Rock Viewpoint',
          text: 'אחת מהתצפיות הפחות מוכרות, שווה במיוחד לחובבי השקט והטבע.',
        },
        {
          subtitle: 'נקודת מבט השקיעה',
          text: 'כשמו כן הוא, מושלם לתפוס שקיעה מרהיבה עם בירה ביד.',
        },
      ],
    },
    {
      title: 'קולינריה מקומית ובינלאומית',
      type: 'sub-headers',
      description:
        "האוכל בקו טאו הינו חגיגה של טעמים – מהמטבח התאילנדי החריף ועד פיוז'ן מערבי יצירתי:",
      content: [
        {
          subtitle: 'שוק הלילה של קו טאו',
          text: 'מקום נפלא לארוחה אותנטית: פאד תאי, קארי ירוק, סום טאם (סלט פפאיה חריף) או קינוח מנגו סטיקי רייס -מעדן מנגו עם אורז דביק.',
        },
        {
          subtitle: 'Coconut Monkey',
          text: 'בית קפה בריא ונעים על החוף, מגיש קערות אסאי, טוסטים ומיצים טבעיים.',
        },
        {
          subtitle: 'Blue Heaven',
          text: "מסעדה מודרנית ומומלצת עם נוף לים, תפריט פיוז'ן וטעמים מוקפדים.",
        },
        {
          subtitle: 'Barracuda',
          text: 'מסעדת גורמה עם דגש על מאכלים ים טריים ויין איכותי – חוויה קולינרית של ממש.',
        },
      ],
    },
    {
      title: 'היכן לישון בקו טאו',
      type: 'sub-headers',
      description:
        'אפשרויות הלינה באי מגוונות ונעות בין הוסטלים בסיסיים ועד מלונות בוטיק יוקרתיים:',
      content: [
        {
          subtitle: 'The Haad Tien Beach Resort',
          text: 'ריזורט שקט עם בונגלוס פרטיים על קו המים.',
        },
        {
          subtitle: 'Jamahkiri Spa & Resort',
          text: 'מלון יוקרתי עם ספא, בריכה ונוף מהמם.',
        },
        {
          subtitle: 'Goodtime Adventures',
          text: 'הוסטל פופולרי לצעירים, עם אפשרות להזמין גם קורסי צלילה.',
        },
        {
          subtitle: 'Luna Eco Village',
          text: 'כפר אקולוגי בלב הטבע לחוויה אותנטית וירוקה.',
        },
      ],
    },
    {
      title: 'התניידות באי',
      type: 'sub-headers',
      description: 'ישנן מספר דרכים לחקור את קו טאו:',
      content: [
        {
          subtitle: 'קטנוע',
          text: 'הדרך הנוחה ביותר לחקור את קו טאו הינה באמצעות שכירת קטנוע – רק יש לשים לב כי הכבישים באי תלולים וחלקם אינם סלולים.',
        },
        {
          subtitle: 'סיור בסירת לונג טייל',
          text: 'אלטרנטיבה נעימה, הינה סיור יומי בסירת לונג טייל (סירה ארוכת זנב), שתיקח אתכם לחופים מבודדים, נקודות שנורקלינג נבחרות ואתרים פחות נגישים. אפשר גם להצטרף לסיורי שקיעה בסירה – חוויה קסומה במיוחד.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      type: 'text',
      content:
        'בשורה התחתונה, קו טאו מצליח לשלב שלווה אקזוטית עם הרפתקה ימית סוחפת. זהו מקום שמתאים לזוגות, לתרמילאים, לחובבי טבע ולכל המחפשים חוויה אחרת מתאילנד – רגועה, אותנטית ועוצרת נשימה.\n\nאם הינכם מתלבטים האם להוסיף את קו טאו למסלול הטיול שלכם – התשובה היא חד משמעית – כן, לא תתחרטו!\n\nטיול מהנה!',
    },
  ],
};
